<template>
  <base-dialog :show-dialog="showDialog">
    <template v-slot:body>
      <v-card dark>
        <v-card-title>
          {{ $t('titulos.nomeOferta') }}
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <c-select
                :rotulo="$t('labels.nome') + ' ' + $t('artigos.da') + ' Lista'"
                class="text-caption"
                itemText="itemText"
                itemValue="itemValue"
                :lista="lista"
                :item.sync="nomeLista"
                v-model="nomeLista"
                dense
                dark
                outlined
                auto-select-first
                :disable-lookup="true"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" @click="$emit('close')" class="mt-1">
            <span class="white--text">
              {{ $t('labels.fechar') }}
            </span>
          </v-btn>
          <v-spacer> </v-spacer>
          <v-btn color="green" @click="pinObject()" class="mt-1">
            <span class="white--text">
              {{ $t('labels.salvar') }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'

import { mapState } from 'vuex'

export default {
  components: { BaseDialog, cSelect },
  computed: {
    ...mapState('itemModule', ['namesOfferList']),
    lista: function() {
      if (this.namesOfferList)
        return this.namesOfferList.map((e) => {
          return {
            itemText: e.LISTAOFERTA,
            itemValue: e.LISTAOFERTA,
          }
        })
      else
        return {
          itemText: 'SEM DADOS',
          itemValue: 'SEM DADOS',
        }
    },
  },
  data: () => {
    return {
      timer: null,
      nomeLista: '',
    }
  },
  methods: {
    pinObject() {
      this.$emit('close')
      this.$emit(
        'objectpin',
        this.nomeLista && this.nomeLista.itemValue
          ? this.nomeLista.itemValue
          : ''
      )
    },
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
